import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import Button from "@mui/material/Button";
import "../../../features/admin-section/features/provider-management/provider-requests/approve-or-reject-popup.scss";

interface InfoPopupProps {
  open: boolean;
  title?: string;
  note: string;
  icon?: React.ReactNode;
  onClose: () => void;
  buttonText?: string;
}

const InfoPopup: React.FC<InfoPopupProps> = ({
  open,
  title,
  note,
  icon,
  onClose,
  buttonText = "OK",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="info-dialog-title"
      aria-describedby="info-dialog-description"
      className="approve-or-reject-popup-wrapper"
    >
      <DialogTitle id="info-dialog-title">
        <div className="header-wrapper">
          <div className="image-wrapper">
            {icon || (
              <InfoIcon
                className="info-icon"
                style={{ fontSize: 32, color: "#3A6164" }}
              />
            )}
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="info-dialog-description">
          {title && <p className="title-content">{title}</p>}
          <p className="desc-content">{note}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          className="action-btn approve-btn"
          autoFocus
          type="button"
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoPopup;
